module.exports = __webpack_public_path__ + "static/media/8-9.3bf3bf59.mp3";